<div class="modal-wrap">
  <span class="material-symbols-outlined">
    warning
  </span>
  <h1>{{'PHONE_WARNING.TEXT' | translate}}</h1>
</div>
